function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.084 1.846c-.057-.797-.752-1.427-1.601-1.427H5.21L5.1.422c-.835.054-1.495.718-1.495 1.529v.52l.005.069c.036.25.26.441.53.441a.523.523 0 00.535-.51v-.52l.005-.07a.527.527 0 01.53-.441h9.273l.072.005a.52.52 0 01.463.506v12.936l-.005.07a.527.527 0 01-.53.44H5.21l-.072-.004a.52.52 0 01-.463-.506v-.5l-.005-.069a.527.527 0 00-.53-.441.523.523 0 00-.535.51v.5l.004.105c.056.797.752 1.427 1.601 1.427h9.273l.11-.004c.835-.054 1.494-.717 1.494-1.528V1.95l-.003-.105z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.485 4.334c.752 0 1.361.61 1.361 1.361v5.447c0 .752-.61 1.362-1.361 1.362H2.649c-.752 0-1.362-.61-1.362-1.362V5.695c0-.752.61-1.361 1.362-1.361h5.836zm-3.89 1.923H3.523l1.423 2.119-1.52 2.256h1.04l1.066-1.655 1.066 1.655h1.11L6.159 8.426l1.439-2.169H6.55l-.969 1.574-.987-1.574z"
});

function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgExport;